/**
 * Shared keystroke filter for currency inputs (donation amounts and the like).
 *
 * Accepts only what someone can be part-way through typing towards a dollar
 * amount: nothing yet, digits, and at most two decimal places. "12", "12."
 * and "12.50" all pass so the field stays editable mid-entry; "12.555" and
 * "12.5.5" do not.
 *
 * A bare "." is rejected on purpose - it slips through the looser
 * /^\d*\.?\d{0,2}$/ shape, and parseFloat(".") is NaN, which JSON.stringify
 * then writes out as null and the typed amount is silently lost on save.
 *
 * Only ever call this on a value the user just typed. Selecting an existing
 * amount must not be filtered: pages saved before this cap existed can hold
 * more than two decimals, and running a click handler through here makes
 * those options impossible to pick.
 */
export const isValidAmountKeystroke = (value: string): boolean =>
  /^(\d+(\.\d{0,2})?)?$/.test(value ?? "");
